import { Box, Chip, Metadata, useTranslations } from "@bsm/component";
import { THoliday } from "@bsm/graphql";
import moment from "moment";
import { Link } from "react-router-dom";
import { useUrlParamsValue } from "@bsm/component";

export const SchoolHolidayListItem = (props: Partial<THoliday>) => {
    const [START_DATE, END_DATE, COMMENT, YEAR] = useTranslations(i18n);
    const urlParams = useUrlParamsValue();

    return (
        <Box className="mb-4 p-4 w-full">
            <div className="flex w-full justify-between items-start">
                <Link to={`${props.id}?${urlParams}`}>
                    <div className="">
                        <div className="flex items-center gap-2 mb-2">
                            <h4 className="font-semibold text-lg">{props.value}</h4>
                            <Chip label={props.year} className="bg-default" />
                        </div>
                        <Metadata
                            label={START_DATE}
                            value={moment(props.startDate).format('DD MMM YYYY')}
                        />
                        <Metadata
                            label={END_DATE}
                            value={moment(props.endDate).format('DD MMM YYYY')}
                        />
                    </div>
                </Link>
            </div>
        </Box>
    );
};

const i18n = [
    "BSMRH.Holiday.Form.StartDate.Label",
    "BSMRH.Holiday.Form.EndDate.Label",
    "BSMRH.Holiday.Form.Comment.Label",
    "std_year"
];